module.exports = __webpack_public_path__ + "static/media/java.b7c63ab0.svg";